import { gql } from 'graphql-request';

// Sprint 25, story-134. The reimagined subcontractor page's three backend queries. See
// docs/architecture.md's `## Sprint 25` -> story-134 for the shared predicate every one of these
// (indirectly, via SubcontractorResolver) uses: task.organizationId = caller AND
// delegateOrganizationId = sub.

export const getSubcontractorRoster = gql`
  query getSubcontractorRoster {
    getSubcontractorRoster {
      organizationId
      name
      projectsCount
      activeTasksCount
      completeTasksCount
      overdueCount
      awaitingApprovalCount
      openIncidentsCount
      attention
    }
  }
`;

export const getSubcontractorOverview = gql`
  query getSubcontractorOverview($subOrganizationId: String!, $projectIds: [String!]) {
    getSubcontractorOverview(subOrganizationId: $subOrganizationId, projectIds: $projectIds) {
      subOrganizationId
      subOrganizationName
      header {
        since
        projectsCount
        tasksTotal
        tasksActive
        tasksComplete
        tasksCancelled
        agreedPriceTotal
        tasksWithoutPriceCount
      }
      totals {
        health
        completion
        overdueCount
        completedLateCount
        avgDaysLate
        earned
        ofAgreedPct
        atRisk
        dueThisWeekCount
      }
      projects {
        projectId
        projectName
        health
        completion
        completeCount
        countableCount
        dueThisWeekCount
        agreed
        earned
        remaining
        atRisk
        tasks {
          taskId
          name
          status
          startTime
          endTime
          budget
          daysLate
          daysLeft
          completedAt
          countable
          origin {
            type
            amount
          }
          materials {
            name
            quantity
            unit
            pricePerUnit
            isMine
          }
          equipment {
            name
            estimatedHours
            pricePerUnit
            isMine
          }
        }
      }
      exceptions {
        awaitingApproval {
          taskId
          taskName
          projectId
          projectName
          reason
          incidentId
          date
        }
        openIncidents {
          taskId
          taskName
          projectId
          projectName
          reason
          incidentId
          date
        }
        overdue {
          taskId
          taskName
          projectId
          projectName
          reason
          incidentId
          date
        }
      }
      materialsEquipmentRollup {
        materialsCount
        equipmentCount
        priceTotal
      }
    }
  }
`;

export const getSubcontractorBids = gql`
  query getSubcontractorBids($subOrganizationId: String!) {
    getSubcontractorBids(subOrganizationId: $subOrganizationId) {
      budgetRequestId
      taskId
      taskName
      projectId
      projectName
      sentAt
      maxBudgetAmount
      proposedAmount
      outcome
      agreedAmount
    }
  }
`;

const SubcontractorGraphQL = {
  queries: {
    getSubcontractorRoster,
    getSubcontractorOverview,
    getSubcontractorBids,
  },
};

export default SubcontractorGraphQL;
